module.exports = __webpack_public_path__ + "img/barclays_logo.90c51ce7.svg";